<template>
<div>
    <pt-life-experience-pavilion-form ref="form" class="pt-hospital-form__withData" :lifeExperienceHallsDetail="lifeExperienceHallsDetail" :isEdit="isEdit" :organizationList="organizationList"></pt-life-experience-pavilion-form>
</div>
</template>

<script>
import PtLifeExperiencePavilionForm from './form'
export default {
  name: 'pt-life-experience-pavilion-form__withData',
  components: {
    'pt-life-experience-pavilion-form': PtLifeExperiencePavilionForm
  },
  computed: {
    form () {
      return this.$refs.form
    }
  },
  props: {
    userLogin: {
      type: String,
      default: ''
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      lifeExperienceHallsDetail: {},
      organizationList: []
    }
  },
  methods: {
    getCompanyList () {
      let data = {
        pageableParam: {
          page: 0,
          size: 9999
        },
        type: 'BRANCH'
      }
      // let organizationId = this.$auth.user().organizationId
      this.$store.dispatch('getBranchCompanyList', data).then(res => {
        var newArr = []
        res.data.forEach(ele => {
          var obj = {}
          obj.value = ele.id
          obj.label = ele.fullName
          newArr.push(obj)
        })
        // if (this.HAS_PERM_DOCTOR_OPERATION) {
        this.organizationList = newArr
        // } else if (this.HAS_PERM_REGION_DOCTOR_OPERATION) {
        //   newArr.forEach(item => {
        //     if (item.value === organizationId) {
        //       this.organizationList.push(item)
        //     }
        //   })
        // }
      }).catch(err => {
        this.$message.error(err || '获取分/子公司列表失败')
      })
    },
    getlifeExperienceHallsDetail () {
      this.$emit('detailLoading', true)
      this.$store.dispatch('getLifeExperienceHallsDetail', this.$route.params.id).then(res => {
        this.$emit('detailLoading', false)
        this.lifeExperienceHallsDetail = res
      }).catch(err => {
        this.$emit('detailLoading', false)
        this.$message.error(err || '获取生命体验馆详情失败')
      })
    },
    submit () {
      this.form.validate().then(formValue => {
        this.form.address.address.validate().then(res => {
          if (!this.isEdit) {
            this.createLifeExperienceHallsList(formValue)
          } else {
            this.editLifeExperienceHallsList(formValue)
          }
        })
      })
    },
    createLifeExperienceHallsList (data) {
      this.$emit('submitLoading', true)
      this.$store.dispatch('createLifeExperienceHallsList', data).then(res => {
        this.$emit('submitLoading', false)
        this.$message.success('新建生命体验馆成功')
        history.go(-1)
      }).catch(errorMessage => {
        this.$emit('submitLoading', false)
        this.$message.error(errorMessage || '新建生命体验馆失败')
      })
    },
    editLifeExperienceHallsList (data) {
      this.$emit('submitLoading', true)
      this.$store.dispatch('editLifeExperienceHallsList', data).then(res => {
        this.$emit('submitLoading', false)
        this.$message.success('编辑生命体验馆成功')
        history.go(-1)
      }).catch(err => {
        this.$emit('submitLoading', false)
        this.$message.error(err || '编辑生命体验馆失败')
      })
    }
  },
  created () {
    this.getCompanyList()
    if (this.isEdit) {
      this.getlifeExperienceHallsDetail()
    }
  }
}
</script>
